import { ComponentStyles } from '@cast/design-system';
import { Organization, OrganizationType } from '@cast/types';
import { createRandomizer } from '@cast/utils';

import { enterpriseOrganizationColorMap } from './organizationAvatarConstants';

export const getOrganizationColorIndex = (
  organization: Organization
): number => {
  if (
    'childOrderId' in organization &&
    organization.childOrderId !== undefined &&
    organization.childOrderId !== null
  ) {
    return organization.childOrderId;
  }
  return createRandomizer({
    token: organization.id + organization.createdAt,
  }).random({ min: 0, max: enterpriseOrganizationColorMap.length - 1 });
};

export const getOrganizationAvatarStyles = (
  organization: Organization | undefined,
  colorIndex: number
): ComponentStyles => {
  const isEnterprise = organization?.type === OrganizationType.ENTERPRISE;

  const colorEntry = enterpriseOrganizationColorMap.at(
    colorIndex % enterpriseOrganizationColorMap.length
  );

  const backgroundColor = isEnterprise
    ? colorEntry?.enterprise ?? colorEntry?.backgroundColor
    : colorEntry?.backgroundColor;

  const color = isEnterprise ? backgroundColor : colorEntry?.color;

  return {
    color: color,
    backgroundColor: isEnterprise ? 'none' : backgroundColor,
    borderColor: isEnterprise ? backgroundColor : 'none',
    borderStyle: isEnterprise ? 'solid' : 'none',
    borderWidth: isEnterprise ? '2px' : 'none',
  };
};

export const getOrganizationDisplayName = (
  organization: Organization | undefined,
  placeholderName: string = ''
): string => {
  return organization?.name || placeholderName;
};
